import { ControlledCheckBox } from '@drycut/controlled-components';
import { InfoButton, Stack } from '@drycut/ui-components';
import { useFormContext } from 'react-hook-form';

import { ControlledNameField } from '../../../ControlledNameField';
import { ControlledValidationPhoneField } from '../../../ControlledValidationPhoneField';
import { useCheckoutStore } from '../../checkoutStore';

export function CustomerDetailsStep(): React.ReactElement {
  const { setValue } = useFormContext();
  const manual = useCheckoutStore((state) => state.manual);
  const setPhoneValidated = useCheckoutStore((state) => state.setPhoneValidated);
  const setSelectedCoupon = useCheckoutStore((state) => state.setSelectedCoupon);

  const finishedPhoneValidation = () => {
    setPhoneValidated(true);
    setValue('couponCode', ''); // Reset coupon code after phone validation
    setSelectedCoupon(undefined); // Reset selected coupon after phone validation
  };

  const handleValidationError = () => {
    setPhoneValidated(false);
  };

  return (
    <Stack gap={2}>
      <ControlledValidationPhoneField
        placeholder="Telefonnummer"
        onSuccessfulValidation={finishedPhoneValidation}
        onValidationError={handleValidationError}
      />

      <Stack gap={2} as="fieldset">
        <ControlledNameField
          align="left"
          placeholder="Vorname"
          autoComplete={manual ? 'off' : 'name'}
          noLabel
        />

        <Stack gap={2} direction="row">
          <ControlledCheckBox name="silentBooking" label="Silent Cut" />
          <InfoButton
            title="Silent cut"
            text="Nach der Beratung und Besprechung des Schnitts geniesse ich meinen Schnitt heute gerne in Ruhe und verzichte auf Smalltalk."
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
